module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/streams.dynamodb-2012-08-10.paginators.json
// module id = 361
// module chunks = 0